import { memo, useCallback } from 'react'

import { Divider } from '@mui/material'
import { Organization } from '@nativewaves/nw-cloud-sdk/org'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

import { MenuItemCopyId, MenuItemDelete } from '@shared/components/MaterialUIEnhancements/Menu/MenuItem'
import { RowActionsProps } from '@shared/components/Table'
import { useOrganizationDeleteMutation } from 'hooks/mutations/org'

const RowActionsRaw = ({ row, onClose }: RowActionsProps<Organization>) => {
  const { t } = useTranslation(['common', 'domain', 'entity'])
  const { enqueueSnackbar } = useSnackbar()

  const { mutate: deleteOrganization } = useOrganizationDeleteMutation()

  const handleDeleteOrganization = useCallback(() => {
    onClose()

    deleteOrganization(
      { organizationId: row.original.id },
      {
        onSuccess: () =>
          enqueueSnackbar(t('domain:My.Organization.nameDelete', { name: row.original.name }), { variant: 'success' }),
      },
    )
  }, [deleteOrganization, enqueueSnackbar, onClose, row.original.id, row.original.name, t])

  return (
    <>
      <MenuItemCopyId onSuccess={onClose} id={row.original.id} />
      <Divider sx={{ my: 1 }} component="li" />
      <MenuItemDelete onConfirm={handleDeleteOrganization} />
    </>
  )
}

export const RowActions = memo(RowActionsRaw)
